// filepath: c:\Users\Usuário\Desktop\Probrain\maratona-web\src\components\Lists\GraphicsAdmin\RadarGraphic\index.tsx
import React, { createRef, useContext } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import pClasses from "../../ListUsersAndAdmins.module.scss";
import RoundButton from "../../../Buttons/RoundButton";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useTranslation } from "react-i18next";
import SessionContext from "../../../../context/sessionContext";

// Register Chart.js components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

interface Interface {
  fetchedJourney?: any;
  className?: string;
}

export default function RadarGraphic({ fetchedJourney, className = "" }: Interface) {
  const { t } = useTranslation();
  const ref: any = createRef();
  const cSession = useContext(SessionContext);
  const { user } = cSession ?? {};

  const pdfDownload = () => {
    const input: any = document.getElementById(ref);
    html2canvas(input).then((canvas: any) => {
      const pdf = new jsPDF("p");
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "png", 30, 0, 150, 200);
      pdf.save(
        `${user ? String(user?.registry).replace(".", "_") : "RadarChart"}.pdf`
      );
    });
  };

  const _content = fetchedJourney && (
    <>
      <RoundButton
        small
        className={pClasses.BtnPdfSecondary}
        text={t("global.print_partial_report")}
        faIcon={faFilePdf}
        title={t("BAIXAR PDF")}
        onClick={() => pdfDownload()}
      />
      <div
        className={pClasses.ListRadar}
        id={ref}
        style={{ paddingBottom: 150, paddingTop: 0 }}
      >
        <Radar
          data={{
            labels: [
              "Localização Sonora",
              "Fechamento OD",
              "Fechamento OE",
              "Figura fundo OD",
              "Figura Fundo OE",
              "Resolução Temporal",
              "Ordenação Temporal",
              "Dicótico Sequencial",
              "Dicóticos OD",
              "Dicóticos OE",
            ],
            datasets: [
              {
                label: "Avanço(%)",
                data:
                  fetchedJourney?.reavaliation?.map(
                    (test: any, index: any) =>
                      (test.test_score * 10 + test.test_score_time) / 2 -
                      (fetchedJourney?.avaliation[index].test_score * 10 +
                        fetchedJourney?.avaliation[index].test_score_time) /
                        2
                  ) || [],
                backgroundColor: "rgba(10, 65, 72, 0.5)",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgb(10, 65, 72)",
              },
              {
                label: "Acertos Avaliação(%)",
                data:
                  fetchedJourney?.avaliation?.map(
                    (test: any) =>
                      (test.test_score * 10 + test.test_score_time) / 2
                  ) || [],
                backgroundColor: "rgba(181, 245, 230, 0.5)",
                borderColor: "rgb(181, 245, 230)",
                pointBackgroundColor: "rgb(181, 245, 230)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgb(181, 245, 230)",
              },
              {
                label: "Acertos Reavaliação(%)",
                data:
                  fetchedJourney?.reavaliation?.map(
                    (test: any) =>
                      (test.test_score * 10 + test.test_score_time) / 2
                  ) || [],
                backgroundColor: "rgba(29, 134, 136, 0.5)",
                borderColor: "rgb(29, 134, 136)",
                pointBackgroundColor: "rgb(29, 134, 136)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgb(29, 134, 136)",
              },
            ],
          }}
          options={{
            layout: {
              padding: {
                right: 25,
              },
            },
            plugins: {
              title: {
                display: true,
                text: "Months and Rev",
              },
            },
          }}
        />
      </div>
    </>
  );

  return (
    <div className={className + " " + pClasses.TableArea}>
      {_content}
    </div>
  );
}